window.AutenticarVendedorController = ControllerBase.extend({
    name: "AutenticarVendedorController",
    framework: "knockout",

    region: "body",

    newModel: function() {

        return {
            SenhaAtual: null,
            NovaSenha: null,
            Confirmacao: null
        };
    },

    initialize: function() {
        this.setModel(this.newModel());
        this.setarFocus();
    },

    events: {
        'keydown #LoginAntigoVendedor_txtSenha': "digitandoSenhaVendedor",
        'click #LoginAntigoVendedor_btnSubmit': "validarSenha",
   },
    digitandoSenhaVendedor: function () {
        
        $("#LoginAntigoVendedor_btnSubmit").enable(true);
        $("#LoginAntigoVendedor_btnSubmit").text("Ok");
    },
    validarSenha: function () {
        
        $("#LoginAntigoVendedor_btnSubmit").text("Aguarde...");

        setTimeout(function () {
            $("#LoginAntigoVendedor_btnSubmit").enable(false);
        }, 10)

        try {
            $(this).closest("form")[0].submit();
        } catch(e) {
        exceptionThrown = e;
        }
    },
    alterarSenha: function() {

        if (!global.isFormValid($("#form-alterar-senha-vendedor"))) {
            return;
        }
        var self = this;
        global.ajax({
            url: "/Vendedor/AlterarSenha",
            type: "post",
            cache: false,
            data: {
                senhaAtual: this.model.SenhaAtual(),
                novaSenha: this.model.NovaSenha()
            },
            success: function(data) {
                if (!data || data.HasErrors) {
                    return;
                }
                self.senhaAlterada();
            }
        });
    },

    setarFocus: function () {
        
        $("input[name=SenhaVendedor]").focus();
    },

    senhaAlterada: function() {
        global.showSuccessMessage("Alteração de senha confirmada");
        $("#modalAlterarSenhaVendedor").modal("hide");
    },

    mostrarModal: function(model, e, senhaDigitada) {
        this.limparModel();
        this.model.SenhaAtual(senhaDigitada);
        $("#modalAlterarSenhaVendedor").modal("show");
        $('#modalAlterarSenhaVendedor').on('hidden.bs.modal', $.proxy(function () {
            this.setarFocus();
        }, this));
    },

    limparModel: function() {
        this.model.SenhaAtual(undefined);
        this.model.NovaSenha(undefined);
        this.model.Confirmacao(undefined);
    }
});